import React from 'react';
import { useNavigate } from 'react-router-dom';
import IntroTopSection from '../../../components/Introduction/IntroTopSection';
import IntroSubHeading from '../../../components/Introduction/IntroSubHeading';

const CEOGreetingPC = () => {

  return (
    <div className="announcement-list-page intro-info-page">

      <IntroTopSection />

      {/* Main Content */}
      <main className="main-content">
        <IntroSubHeading heading="대표인사 인사말" />

        <div className="ceo-content-section">

          <div className="image45-section">
            <img src="/images/image45.png" alt="CEO Greeting" className="image45" />
            <img src="/images/ceo_greetings2.png" alt="CEO Greeting" className="ceo-greeting-black" />
          </div>

          <div className="ceo-content-wrapper">
            <div className="logo-section">
              <div className="logo-container">
                <img src="/images/image46.png" alt="CEO Greeting" className="ceo-logo" />
              </div>
            </div>

            <article className="content-text">
              <span className="main-heading ceo-greeting-bold-text">
                <span className="text-style-1">안녕하십니까.</span><br />
                강화파라다이스 대표이사 <span className="text-style-2">강익순</span>입니다.
              </span>

              <span className="body-text ceo-greeting-text">
                홈페이지를 방문해 주신 가족 여러분께 먼저 감사의 인사를 드립니다.<br />
                저희 <span className="text-style-1">강화파라다이스 추모원</span>은 <span className="text-style-1">대한민국의 선진 장례문화</span>를 정착시키고자 설립되었습니다.
              </span>

              <span className="body-text">
                급속하게 다변화되어가는 현대사회만큼 고인에 대한 추모의 방식도다양하게 변해왔습니다. 하지만 그 속에서도 고인에 대한 애틋한 감정과 추억은 변치않음을 알고 있습니다. 추모 문화의 변화 속에서 20년간 한자리를 지켜온 강화파라다이스 추모원은 전통적인 추모와 더불어 현대적인 감성의 추모 문화가 함께 공존할수 있도록 대표와 임직원 모두가 힘쓰고 있습니다.
              </span>

{/* 
              <span className="body-text">
                강화파라다이스 추모원은 전문성 있는 관리체계와 방문하시는 모든 분들께 정성을다하는 서비스를 제공해드릴 것을 약속 드립니다. 고인을 모시게 된 가족분들의근심걱정은 덜어 드리고 언제든 부담 없이 찾아오실 수 있도록 많은 노력을 기울이고있습니다. 앞으로도 가족여러분들의 관심과 격려에 보답하여 자랑스러운 추모원이되도록 가꾸어 나가겠습니다.
              </span> */}
              <span className="body-text">
                강화파라다이스 추모원은 전문성 있는 관리체계와 방문하시는 모든 분들께 정성을다하는 서비스를 제공해드릴 것을 약속 드립니다.<br />
                고인을 모시게 된 가족분들의 근심걱정은 덜어 드리고 언제든 부담 없이 찾아오실 수 있도록 많은 노력을 기울이고 있습니다.<br />
                앞으로도 가족여러분들의 관심과 격려에 보답하여 자랑스러운 추모원이 되도록 가꾸어 나가겠습니다.
              </span>

            </article>
          </div>
        </div>
      </main>


    </div>
  );
};

export default CEOGreetingPC; 